import type { Row } from '@tanstack/react-table';
import type { ActionItemProps } from './ticlick-table-table-actions';
import React from 'react';

export type RowActionItemsProps<T> = Omit<
  ActionItemProps<T>,
  'visibility' | 'render'
> & {
  render(row: Row<T>): React.ReactNode;
};

export default function TiclickTableRowActions<T>({
  row,
  actions,
}: {
  row: Row<T>;
  actions: RowActionItemsProps<T>[];
}) {
  return (
    <div className='flex items-center gap-2'>
      {actions
        .filter((action) => action.isDisplay !== false)
        .map((action) => {
          if (!action.render(row)) return null;
          return (
            <div
              key={action.key}
              className='transition-transform empty:hidden duration-200 ease-in-out 
                   opacity-0 translate-y-2 scale-95 
                   data-[state=visible]:opacity-100 data-[state=visible]:translate-y-0 data-[state=visible]:scale-100'
              data-state='visible'
            >
              {action.render(row)}
            </div>
          );
        })}
    </div>
  );
}
